import * as types from '../../mutation-types';

/**
 * Update the page loading state
 */
export function setPageLoading({ commit }, { isLoading }) {
    commit(types.SET_PAGE_LOADING, { isLoading });
}

/**
 * Set the current page siblings urls for a quick language change update
 */
export function setLanguageSiblings({ commit }, { languageSiblings }) {
    commit(types.SET_PAGE_LANGUAGE_SIBLINGS, { languageSiblings });
}

/**
 * Set the page containers AKA cms placeholders
 */
export function setContainers({ commit }, { containers }) {
    commit(types.SET_PAGE_CONTAINERS, { containers });
}

/**
 * Set the color of the page with the theme
 */
export function setTheme({ commit }, { theme }) {
    commit(types.SET_PAGE_THEME, { theme });
}
